import { ChatPage } from '@frontend/features/chat/components/ChatPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/chat/$conversationId/')({
  component: ChatPage,
});
